export default __webpack_public_path__ + "static/media/fleche_large.6707116c.svg";